import { jsx } from "react/jsx-runtime";
import { Box, Stack } from "braid-design-system";
import { desktopAnlayticsEventToMobile } from "../../../EmployerFooter/AuthenticatedFooterLinks/AuthenticatedFooterLinks.mjs";
import { CustomHeaderMobileLink } from "./HeaderLink.mjs";
import { isActive } from "./MobileSubNavigation.css.mjs";
const MobileSubNavigation = ({
  activeSubTabId,
  items,
  onMenuItemClick,
  linkRenderer
}) => /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Stack, { space: "medium", children: items.map(({ id, label, ...subHeaderNavItemProps }, index) => /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(
  CustomHeaderMobileLink,
  {
    "data-analytics": subHeaderNavItemProps["data-analytics"],
    "data-test": subHeaderNavItemProps["data-test"],
    href: subHeaderNavItemProps.href,
    onClick: onMenuItemClick,
    active: id === activeSubTabId,
    activeStyle: isActive,
    linkRenderer,
    isNested: true,
    analyticsEvent: desktopAnlayticsEventToMobile(
      subHeaderNavItemProps.analyticsEvent
    ),
    children: label
  }
) }, `mobile-nav-subitem-${index}`)) }) });
export {
  MobileSubNavigation
};
